module.exports = __webpack_public_path__ + "img/west-vvip-gal-5.3c301fa5.jpg";